import { render } from "./Svg.vue?vue&type=template&id=27ff68da"
import script from "./Svg.vue?vue&type=script&lang=js"
export * from "./Svg.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__